<template>
  <v-app>
    <v-main>
      <v-container>

        <h1> TÉRMINOS Y CONDICIONES DEL SERVICIO </h1>

        <p>&nbsp;</p>

        <strong> El uso responsable de su cuenta. </strong>

        <p>&nbsp;</p>

        <ul>

          <li> Mantener confidenciales los datos de ingreso (usuario, contraseña). </li>
          <li> Notificar oportunamente al correo de <strong>USAMEDIC</strong> de cualquier uso o ingreso no autorizados a la cuenta  o cualquier otra infracción a la seguridad de la misma. <strong>USAMEDIC</strong> no será responsable en ningún caso por las acciones realizadas desde la cuenta del usuario.  </li>
          <li> Toda acción realizada dentro de la aplicación será vigilada a fin de asegurar su buen uso.  </li>
          <li> De hallarse un uso inadecuado, el usuario será sancionado por <strong>USAMEDIC</strong>. </li>

        </ul>

        <p>&nbsp;</p>

        <strong> Delimitación de responsabilidad </strong>

        <p>&nbsp;</p>

        <ul>

          <li> <strong>USAMEDIC</strong> realiza todos los esfuerzos para ofrecer la información más actualizada y exacta  en sus espacios de difusión. Sin perjuicio de lo anterior, puede suceder situaciones inesperadas de fallas y/o errores. En dichos casos, <strong>USAMEDIC</strong> no será responsable del daño, perjuicio directo o indirecto, incidental, consecuente o especial que se derive del uso de la información contenida en este sitio. </li>
          <li> <strong>USAMEDIC</strong> no garantiza, en ningún caso, la suficiencia, exactitud e integridad de la información contenida en la aplicación, por lo que no asumirá ninguna clase de responsabilidad por los errores o las omisiones en las que pudiera incurrir. Los visitantes son enteramente responsables de verificar y evaluar la exactitud, integridad y la utilidad de cualquier información que se encuentre disponible en la aplicación. </li>
          <li> La aplicación no garantiza un servicio libre e interrumpido de la aplicación pero sí declara su voluntad de efectuar los esfuerzos que, dentro de lo razonables, permitan alcanzar su disponibilidad por el mayor tiempo posible. </li>

        </ul>

        <p>&nbsp;</p>

        <strong> Modificaciones a los Términos y Condiciones </strong>

        <p>&nbsp;</p>

        <ul>
          <li> <strong>USAMEDIC</strong> se reserva el derecho de modificar el contenido y alcance de los presentes Términos y Condiciones deu uso en cualquier momento y según lo considere necesario. El usuario estará obligado a sujetarse a dichas modificaciones, una vez que éstas entren en vigor. </li>
        </ul>

        <p>&nbsp;</p>

        <strong> Condiciones de uso </strong>

        <p>&nbsp;</p>

        <ul>

          <li> El usuario de <strong>USAMEDIC</strong> se compromete a leer los términos y condiciones generales de manera detallada antes de utilizar la aplicación. Por tanto, ello implica que usted acepta los términos y condiciones generales.  </li>
          <li> Si usted decide no aceptarlos, le solicitamos que no use, ni acceda, ni manipule la información de los servicios ofrecidos por <strong>USAMEDIC</strong>, ya que usted estaría haciendo un uso inadecuado del mismo.  </li>
          <li> Para preguntas, sugerencias o mayor información sobre los términos y condiciones de uso de <strong>USAMEDIC</strong>, escríbanos a: <strong>USAMEDIC</strong>ina@gmail.com </li>

        </ul>
        <br>
        <strong> Eliminación de datos </strong>
        <p>
          Si usted desea la eliminación de sus datos personales de nuestra base de datos, por favor escríbanos al siguiente correo electrónico e incluya la información solicitada:
          <strong>usamedicina@gmail.com</strong>
        </p>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
}
</script>
